export function refreshCartUi(json_cart_info) {
  clearCartContent();

  // eslint-disable-next-line no-prototype-builtins
  if (!json_cart_info.hasOwnProperty('cart_data') || cartIsEmpty(json_cart_info)) {
    insertHtmlEmptyCartContent();
    return;
  }

  insertHtmlHeaderCartTotal(json_cart_info.cart_data);

  buildAndInsertHtmlItemList(json_cart_info.cart_data.cart_contents);

  // eslint-disable-next-line no-prototype-builtins
  if (json_cart_info.hasOwnProperty('errors')) {
    insertHtmlErrorItem(json_cart_info.errors);
  }

  let num_items = Object.keys(json_cart_info.cart_data.cart_contents).length;
  setCartCountBadge(num_items);

  if (num_items > 0) {
    insertCheckoutButton();
  }

  addScrollToCart();
}

export function displayLoading() {
  if (document.getElementById('three-icon-loading')) {
    document.getElementById('three-icon-loading').classList.remove('d-none');
  }
}

function cartIsEmpty(json_cart_info) {
  // eslint-disable-next-line no-prototype-builtins
  if (json_cart_info.hasOwnProperty('errors') && json_cart_info.errors.length > 0) {
    return false;
  }
  // eslint-disable-next-line no-prototype-builtins
  return !json_cart_info.cart_data.hasOwnProperty('cart_contents') || Object.keys(json_cart_info.cart_data.cart_contents).length <= 0;
}

export function hideError() {
  document.getElementById('error-item').classList.add('visually-hidden');

  let listItems = document.getElementById('error-item').parentElement.querySelectorAll('li:not(#error-item)');
  if (listItems.length <= 0) {
    clearCartContent();
    insertHtmlEmptyCartContent();
  }
}

function insertHtmlErrorItem(errors) {
  if (typeof errors[0] == 'undefined' || errors[0] == null) {
    return;
  }

  let list_error_template = document.querySelector('#mini-cart-list-error');

  let list_error_clone = list_error_template.content.cloneNode(true);

  list_error_clone.getElementById('error-text').innerText = errors.shift();

  let list = document.querySelector('#unordered-mini-cart-list');

  if (typeof list == 'undefined' || list == null) {
    return;
  }

  list.appendChild(list_error_clone);
}

function getTermTypeAbbreviation(term_type) {
  switch (term_type.toUpperCase()) {
    case 'YEARLY' || 'YEAR':
      return '/yr';
    case 'MONTHLY':
      return '/mo';
    case 'SINGLE':
      return '';
    default:
      return '/yr';
  }
}

function buildAndInsertHtmlItemList(json_items) {
  let list_item_template = document.querySelector('#mini-cart-list-item');

  let list_template = document.querySelector('#mini-cart-list');

  let list_clone = list_template.content.cloneNode(true);

  Object.keys(json_items).forEach(function (key) {
    let item_clone = list_item_template.content.cloneNode(true);

    item_clone.querySelector('button.delete.btn.btn-xs.btn-flat.btn-outline.btn-danger.pr-lg').setAttribute('data-item_id', json_items[key].id);

    let product_title = json_items[key].title;

    let price_display = json_items[key].price;

    let domain = json_items[key].options.domain;

    const term = json_items[key].term;

    // eslint-disable-next-line no-prototype-builtins
    const is_multi_year_first_term_discount = json_items[key].options.hasOwnProperty('domain') && term in json_items[key].first_term_discounts && term in json_items[key].first_term_discounts;

    if (is_multi_year_first_term_discount) {
      let domain_tooltip = '<span class="fs-7 d-block pt-2">3-year purchase required. Additional year(s) $' + price_display + '*</span>';

      domain = domain + domain_tooltip;

      let price_astrisk = '<span class="fs-7 text-secondary">* 1st yr</span>';

      price_display = price_display - json_items[key].first_term_discounts[term];

      item_clone.querySelector('span.text-success.fw-semibold').innerHTML = '$' + price_display.toFixed(2) + price_astrisk;
    } else {
      item_clone.querySelector('span.text-success.fw-semibold').textContent = '$' + price_display.toFixed(2);
    }

    item_clone.querySelector('span.product.pull-left.col-xs-8.pl-0').innerHTML = product_title;

    const options = json_items[key]['options'];

    if (is_multi_year_first_term_discount) {
      item_clone.querySelector('span.term-type').textContent = '';
    } else {
      item_clone.querySelector('span.term-type').textContent = options.term_type ? getTermTypeAbbreviation(options.term_type) : json_items[key].termType ? getTermTypeAbbreviation(json_items[key].termType) : '';
    }

    // eslint-disable-next-line no-prototype-builtins
    if (json_items[key].options.hasOwnProperty('domain') && json_items[key].options.domain.length != 0 && json_items[key].product_id != 'account.enhanced') {
      item_clone.querySelector('span.domain.pull-left.col-md-12.pl-0.pr-0').innerHTML = domain;
    } else {
      item_clone.querySelector('span.domain.pull-left').remove();
    }

    list_clone.querySelector('#unordered-mini-cart-list').appendChild(item_clone);
  });

  document.querySelector('#mini-cart-container').appendChild(list_clone);
}

function insertHtmlHeaderCartTotal(json_cart_info) {
  let header_template = document.querySelector('#mini-cart-total-header');

  let header_content_clone = header_template.content.cloneNode(true);

  let num_items = Object.keys(json_cart_info.cart_contents).length;

  header_content_clone.querySelector('span.fw-semibold').textContent = '(' + num_items + ' item' + (num_items !== 1 ? 's' : '') + ')';

  // Remove price total for now
  header_content_clone.querySelector('span.text-success').textContent = '';

  document.querySelector('#mini-cart-container').appendChild(header_content_clone);
}

function insertHtmlEmptyCartContent() {
  let empty_template = document.querySelector('#mini-cart-empty-content');

  let empty_content_clone = empty_template.content.cloneNode(true);

  document.querySelector('#mini-cart-container').appendChild(empty_content_clone);

  setCartCountBadge(0);
}

function insertCheckoutButton() {
  let button_template = document.querySelector('#mini-cart-checkout-button');

  let button_clone = button_template.content.cloneNode(true);

  document.querySelector('#mini-cart-container').appendChild(button_clone);
}

function clearCartContent() {
  document.getElementById('mini-cart-container').innerHTML = '';
}

function setCartCountBadge(cart_count) {
  // eslint-disable-next-line no-undef
  $('.badge-cart-items').html(cart_count);
  // eslint-disable-next-line no-undef
  $('#cart-count').html('(' + cart_count + ')');
}

function getCartOffset() {
  let width = document.getElementById('user-email-container').clientWidth;

  // Leave it be; done pixel pushing, should be half the cartIcon container but width keeps going to 0 after sass changes
  let cartIconLiOffset = 29;

  let langLiOffset = document.querySelector('li.dropdown.dropdown-language').clientWidth;

  let cartContainerLi = parseInt(window.getComputedStyle(document.querySelector('div.container.pb-cart-container')).paddingLeft);

  let totalOffset = langLiOffset + cartContainerLi + cartIconLiOffset;

  let finalRightOffset = width - totalOffset;

  if (finalRightOffset < 0) {
    finalRightOffset = 0;
  }

  return finalRightOffset;
}

export function myNoipDisplayCorrection() {
  let usernameLi = document.getElementById('user-email-container');

  if (typeof usernameLi == 'undefined' || usernameLi == null) {
    return;
  }

  document.getElementById('mini-cart-container').setAttribute('style', 'right: ' + getCartOffset() + 'px');

  window.addEventListener(
    'resize',
    () => {
      let width = document.getElementById('user-email-container').clientWidth;

      // Truncated username; single width
      if (width == 196) {
        document.getElementById('mini-cart-container').setAttribute('style', 'right: ' + 16 + 'px');
        return;
      }

      // UnTruncated username can be a multitude of widths
      if (width != 196) {
        document.getElementById('mini-cart-container').setAttribute('style', 'right: ' + getCartOffset() + 'px');
      }
    },
    false
  );
}

function addScrollToCart() {
  let screenDimensions = getScreenDimensions();

  let cartDimensions = getCartDimensions();

  let navDimensions = getNavDimensions();

  if (screenDimensions.height < cartDimensions.height + navDimensions.height + cartDimensions.topPadding) {
    document.getElementById('unordered-mini-cart-list').setAttribute('style', 'overflow-x:scroll;' + 'max-height:' + (screenDimensions.height - 250).toString() + 'px');

    document.getElementById('unordered-mini-cart-list').classList.add('scrollbar');

    document.getElementById('mini-cart-container').setAttribute('style', 'max-height:' + (screenDimensions.height - 66).toString() + 'px');
  }
}

function getCartContainerTopPadding() {
  return parseInt(getComputedStyle(document.querySelector('.container.pb-cart-container')).getPropertyValue('top'));
}

function getNavDimensions() {
  let dimensions = {};

  let nav = findNavBar();

  if (nav == null) {
    dimensions.width = 0;
    dimensions.height = 0;
    return dimensions;
  }

  dimensions.width = nav.offsetWidth;

  dimensions.height = nav.offsetHeight;

  return dimensions;
}

function findNavBar() {
  let shortstar_nav = document.getElementById('way-header-wrap');

  if (shortstar_nav != null && shortstar_nav != undefined) {
    return shortstar_nav;
  }

  let mynoipNav = document.getElementById('main-navbar');

  if (mynoipNav != null && mynoipNav != 'undefined') {
    return mynoipNav;
  }

  return null;
}

function getCartDimensions() {
  let dimensions = {};

  if (document.getElementById('mini-cart-container').style.maxHeight) {
    document.getElementById('mini-cart-container').style.maxHeight = '';
  }

  if (!document.querySelector('div.container.pb-cart-container').classList.contains('in')) {
    getHiddenCartDimensions(dimensions);
    return dimensions;
  }

  dimensions.width = document.getElementById('mini-cart-container').offsetWidth;

  dimensions.height = document.getElementById('mini-cart-container').offsetHeight;

  dimensions.topPadding = getCartContainerTopPadding();

  return dimensions;
}

// Used to get dimensions of cart because disply:none will have dimensions 0
function getHiddenCartDimensions(dimensions) {
  document.getElementById('mini-cart-container').setAttribute('style', 'visibility:hidden');

  document.querySelector('div.container.pb-cart-container').classList.add('in');

  dimensions.width = document.getElementById('mini-cart-container').offsetWidth;

  dimensions.height = document.getElementById('mini-cart-container').offsetHeight;

  dimensions.topPadding = getCartContainerTopPadding();

  document.querySelector('div.container.pb-cart-container').classList.remove('in');

  document.getElementById('mini-cart-container').setAttribute('style', '');

  return dimensions;
}

function getScreenDimensions() {
  let dimensions = {};

  dimensions.width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

  dimensions.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  return dimensions;
}
